import React from "react";
import MarketMoodChart from "./MarketMoodChart";

const ChartContainer = ({ data }) => {
  return (
    <div className="h-[450px] w-full pt-4 rounded-lg shadow flex flex-col mt-16 bg-p400">
      <h1 className="text-lg font-semibold text-p300 text-left px-4">
        Market mood
      </h1>
      <div className=" mt-4 flex flex-col items-center relative bg-p400">
        {data && data.market_mood && (
          <div className="chart-warning-desktop">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none">
              <path
                d="M9 5.36364V9M9 11.9091V12.2727M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="warning-text-desktop">{data.market_mood.messsage}</p>
          </div>
        )}
        {data && data.market_mood && (
          <div className="chart-desktop mt-8">
            <MarketMoodChart value={data.market_mood.value} />

            <div className="chart-result-desktop">
              {data.market_mood.value > 0 && data.market_mood.value < 25 && (
                <div className="flex flex-col text-center ">
                  <div className="text-p300 font-medium text-2xl text-[#FF420E]">
                    {data.market_mood.value}
                  </div>
                  <div className="text-md font-medium">Extreme Fear</div>
                </div>
              )}
              {data.market_mood.value >= 25 && data.market_mood.value < 50 && (
                <div className="flex flex-col text-center ">
                  <div className="text-p300 font-medium text-2xl text-[#FF420E]">
                    {data.market_mood.value}
                  </div>
                  <div className="text-md font-medium">Fear</div>
                </div>
              )}
              {data.market_mood.value >= 50 && data.market_mood.value < 75 && (
                <div className="flex flex-col text-center ">
                  <div className="text-p300 font-medium text-2xl">
                    {data.market_mood.value}
                  </div>
                  <div className="text-md font-medium text-[#D9E92C]">
                    Greed
                  </div>
                </div>
              )}
              {data.market_mood.value >= 75.0 &&
                data.market_mood.value <= 100 && (
                  <div className="flex flex-col text-center ">
                    <div className="text-p300 font-medium text-2xl">
                      {data.market_mood.value}
                    </div>
                    <div className="text-md font-medium text-[#5CA81D]">
                      Extreme Greed
                    </div>
                  </div>
                )}
            </div>
          </div>
        )}
        <div className="text-n300 absolute text-sm font-medium bottom-20">
          Last updated : {data?.market_mood.updated_on}
        </div>
      </div>
    </div>
  );
};

export default ChartContainer;
